import React, { useState, useRef } from "react";

import Popover from "@material-ui/core/Popover";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";
import VolumeUpIcon from "@material-ui/icons/VolumeUp";
import { PiSpeakerHigh } from "react-icons/pi";
import VolumeDownIcon from "@material-ui/icons/VolumeDown";

import { Slider } from "@material-ui/core";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
    const t = getTokens(theme.palette.type, theme.palette.primary.main);
    return {
        tabContainer: {
            padding: theme.spacing(2),
            minWidth: 250,
        },
        popoverPaper: {
            width: "100%",
            maxWidth: 350,
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(1),
            [theme.breakpoints.down("sm")]: {
                maxWidth: 270,
            },
        },
        icons: {
            color: "inherit",
        },
        volumeSlider: {
            color: t.brand,
            height: 6,
            "& .MuiSlider-track": {
                border: "none",
                height: 6,
                borderRadius: 3,
            },
            "& .MuiSlider-thumb": {
                height: 16,
                width: 16,
                marginTop: -5,
                backgroundColor: t.paper,
                border: "2px solid currentColor",
                boxShadow: "none",
                "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
                    boxShadow: t.shadow.glow,
                },
            },
            "& .MuiSlider-rail": {
                color: t.lineStrong,
                opacity: 1,
                height: 6,
                borderRadius: 3,
            },
        },
        volumeContainer: {
            alignItems: "center",
            display: "flex",
            gap: theme.spacing(2),
        },
        volumeIcon: {
            color: t.textSecondary,
            fontSize: "1.25rem",
        },
        sliderContainer: {
            flex: 1,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
    };
});

const NotificationsVolume = ({ volume, setVolume }) => {
    const classes = useStyles();

    const anchorEl = useRef();
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen((prevState) => !prevState);
    };

    const handleClickAway = () => {
        setIsOpen(false);
    };

    const handleVolumeChange = (event, value) => {
        setVolume(value);
        localStorage.setItem("volume", value);
    };

    return (
        <>
            <IconButton
                className={classes.icons}
                onClick={handleClick}
                ref={anchorEl}
                aria-label="Open Notifications"
                // color="inherit"
                // color="secondary"
            >
                <PiSpeakerHigh />
            </IconButton>
            <Popover
                disableScrollLock
                open={isOpen}
                anchorEl={anchorEl.current}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                classes={{ paper: classes.popoverPaper }}
                onClose={handleClickAway}
            >
                <List dense className={classes.tabContainer}>
                    <div className={classes.volumeContainer}>
                        <VolumeDownIcon className={classes.volumeIcon} />
                        <div className={classes.sliderContainer}>
                            <Slider
                                value={Number(volume)}
                                className={classes.volumeSlider}
                                aria-labelledby="volume-slider"
                                step={0.1}
                                min={0}
                                max={1}
                                onChange={handleVolumeChange}
                            />
                        </div>
                        <VolumeUpIcon className={classes.volumeIcon} />
                    </div>
                </List>
            </Popover>
        </>
    );
};

export default NotificationsVolume;